import React, { useEffect } from "react"

import Header from "~/components/dashboard/Layout/Header/OldAppHeader"
import Footer from "~/components/Footer"

const Layout = ({ children }) => {
  useEffect(() => {
    if (process.browser) {
      window.scrollTo({ top: 0, behavior: "smooth" })
    }
  }, [])
  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  )
}

export default Layout
